import css from "./style.scss";
import cx from "classnames";
import { Text } from "preact-i18n";
import useInvoice from "../../hooks/useInvoice";

const TotalCount = () => {
  const { invoice } = useInvoice();

  const currencyIcon = () => {
    switch (invoice.store.currency) {
      case "EUR":
        return "€";
      case "USD":
        return "$";
      default:
        return invoice.store.currency;
    }
  };
  return (
    <div class={cx(css.wrapper, "text-center")}>
      <div class={cx(css.price)}>
        {currencyIcon()}&nbsp;
        {invoice.store.amount}
      </div>
      <div class={cx(css.amount)}>
        <Text id="total.order-amount">Order amount</Text>
      </div>
    </div>
  );
};

export default TotalCount;
